import { call, put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import { AxiosRequestConfig } from 'axios';

import { loginActions as actions } from '.';
import { layoutActions } from '../../Layout/slice';
import { auth } from 'utils/auth';

function* login({ payload }) {
  yield put(actions.setLoginError({ error: '', errorDescription: '' }));
  const params = {
    corporateId: payload.corporateId,
    password: payload.password,
    username: payload.userId,
    grant_type: 'password',
  };
  const url = `v1/oauth/token`;
  const options: AxiosRequestConfig = {
    method: 'POST',
    params,
    headers: {
      Authorization: 'Basic QkRBTUp3dENsaWVudDEwMElkOlhZVmtOelJOekExT08wQkRBTQ',
    },
  };
  try {
    const response = yield call(request, url, options);
    auth.logout();
    auth.setToken(response.access_token, payload.remember);
    auth.setRefreshToken(response.refresh_token);
    yield put(actions.setLoginSuccess(true));
    yield put(layoutActions.getProfileInfo());
  } catch (ex: any) {
    console.log(ex.data.status.data);
    auth.logout();
    if (
      ex.data.status.data.errorCode === '01_400_001' ||
      ex.data.status.data.errorCode === '01_400_002' ||
      ex.data.status.data.errorCode === '01_400_003'
    ) {
      yield put(
        actions.setLoginError({
          error: 'invalid_grant',
          errorDescription: '',
        }),
      );
    }
    if (ex.data.status.data.errorCode === '01_400_004') {
      yield put(
        actions.setLoginError({
          error: 'invalid_grant_count',
          errorDescription: ex.data.status.data.remainingTry,
        }),
      );
    }
    if (ex.data.status.data.errorCode === '01_400_005') {
      yield put(
        actions.setLoginError({
          error: 'invalid_grant_lock',
          errorDescription: '',
        }),
      );
    }
  }
}

export function* loginSaga() {
  yield takeLatest(actions.login, login);
}
